import type { FC, ReactNode } from 'react';

import type { IconName } from '@zen/Styleguide';

import Button from '../../../Button';
import Icon from '../../../Icon';

interface Props {
  groupKey: string;
  isCollapsed: boolean;
  isCollapsible: boolean;
  label: ReactNode;
  onToggleCollapse: () => void;
}

const TableGroupHeader: FC<Props> = (props) => {
  const { groupKey, isCollapsed, isCollapsible, label, onToggleCollapse } = props;

  const collapseIcon: IconName = isCollapsed ? 'zicon-chevron-right' : 'zicon-chevron-down';
  const collapseLabel: string = isCollapsed ? `Expand group ${groupKey}` : `Collapse group ${groupKey}`;

  return (
    <div className="flex items-center gap-2" data-component="table-group-header">
      {isCollapsible && (
        <Button aria-expanded={!isCollapsed} aria-label={collapseLabel} onClick={onToggleCollapse} size="compact" variant="ghost">
          <Icon icon={collapseIcon} />
        </Button>
      )}
      <span>{label}</span>
    </div>
  );
};

export type { Props as TableGroupHeaderProps };
export default TableGroupHeader;
